import React from 'react';
import { Divider, Grid, Header, Icon, Image, Popup, Responsive, Segment, Tab, Table } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import SimpleTwoColumnTableRow from '../../StudentPersonalInfo/SimpleTwoColumnTableRow';
import StudentGrades from './StudentGrades';
import { IconHeader } from '../../Assets/util/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentInfoAndGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentInfo: [],
            studyInfo: [],
            contacts: [],
            loading: true,
            studyProgram: '',
            currentSemester: '',
            semesters: [],
            src: ''
        };
    }

    componentDidMount() {
        axios.get(`students/student/personal-information/${this.props.location.state.studentId}`)
            .then(res => {
                const studentInfo = res.data;
                const { contacts } = studentInfo;

                this.setState({ studentInfo, contacts, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch student info');
            });

        axios.get(`students/student/personal-information/study-program/${this.props.location.state.studentId}/${this.props.location.state.studyProgramId}`)
            .then(res => {
                const studyInfo = res.data;
                this.setState({
                    studyInfo,
                    studyProgram: res.data.department.length ? res.data.department[0].name : res.data.studyProgram,
                    currentSemester: res.data.currentSemester ? res.data.currentSemester === 'ostalo' ? 'Apsolventski staž' : res.data.currentSemester : ''
                });
            })
            .catch(err => {
                console.log('Failed to fetch student info');
            });

        axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support')
            ? `students/${this.props.location.state.sspId}/semesters/overview-for-admin/`
            : `students/${this.props.location.state.sspId}/semesters/overview/`)
            .then(res => {
                this.setState({ semesters: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch student info');
            });

        axios.get(`/students/images/originals/${this.props.location.state.studentId}`)
            .then(res => {
                res.data ?
                    this.setState({ src: res.data })
                    : this.setState({ src: null });
            }).catch(err => {
                this.setState({ src: null });
            });
    }


    render() {
        const {
            studentInfo, contacts, studyInfo, studyProgram, currentSemester, semesters
        } = this.state;
        let assistant = false;
        if (localStorage.getItem('activeRole').substr(0, 8) === 'Asistent') {
            assistant = true;
        }
        const panes = [
            {
                menuItem: { content: <FormattedMessage id="common.personalInfo" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>

                    <Grid columns={2} centered className="stackable">
                        <Grid.Row >
                            <Grid.Column >
                                <Table celled compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan="2"><FormattedMessage id="common.image" /></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body >
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="2"
                                                textAlign="center"
                                                verticalAlign="middle"
                                                style={{
                                                    height: '400px',
                                                    maxHeight: '500px'
                                                }}
                                            >
                                                {
                                                    this.state.src !== null ?
                                                        <Image
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%'
                                                            }}
                                                            src={`data:image/jpeg;base64,${this.state.src}`}
                                                            centered
                                                        />
                                                        : <Image src="https://image.freepik.com/free-icon/user-image-with-black-background_318-34564.jpg" size="medium" centered />
                                                }
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </Grid.Column>
                            <Grid.Column>
                                <Table celled compact>

                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan="2"><FormattedMessage id="professorInputGrades.personalInfo" /></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>

                                        <SimpleTwoColumnTableRow
                                            name={<FormattedMessage id="common.firstName" />}
                                            keyName="firstName"
                                            value={studentInfo.firstName}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name={<FormattedMessage id="common.lastName" />}
                                            keyName="lastName"
                                            value={studentInfo.lastName}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name={<FormattedMessage id="common.fatherName" />}
                                            keyName="fatherFirstName"
                                            value={studentInfo.fatherFirstName}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name={<FormattedMessage id="common.motherName" />}
                                            keyName="motherFirstName"
                                            value={studentInfo.motherFirstName}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name={<FormattedMessage id="common.dateOfBirth" />}
                                            keyName="dateOfBirth"
                                            value={moment(studentInfo.dateOfBirth).format('D. M. YYYY.')}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name={<FormattedMessage id="common.placeOfBirth" />}
                                            keyName="placeOfBirth"
                                            value={studentInfo.placeOfBirth}
                                        />

                                    </Table.Body>
                                </Table>
                                <Table celled compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan="2"><FormattedMessage id="professorInputGrades.contact" /></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>{contacts.map(el => (
                                        <SimpleTwoColumnTableRow
                                            name={el.type}
                                            keyName={el.type}
                                            value={el.value}
                                        />
                                    ))}

                                    </Table.Body>
                                </Table>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="sidebar.study" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive} disabled>
                    <div>
                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorInputGrades.semesters" /></Header>
                                    </Divider>


                                    <Table celled unstackable compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell><FormattedMessage id="common.academicYear" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.semesterNumber" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.semesterName" /></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {semesters.map((el, index) =>
                                                (<Table.Row key={index}>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.semester.academicYear.name}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {(el.semester.name.name === 'ostalo') ? null : el.studyProgramSemester.name}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {(el.semester.name.name === 'ostalo') ? 'Apsolventski staž' : el.semester.name.name}
                                                    </Table.Cell>
                                                </Table.Row>))}
                                        </Table.Body>
                                    </Table>

                                </Grid.Column>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorInputGrades.studyInfo" /></Header>
                                    </Divider>
                                    <Table celled unstackable compact>
                                        <Table.Header>
                                            <Table.Row>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="common.index" />}
                                                keyName="index"
                                                value={studyInfo.index}
                                            />
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="common.studyType" />}
                                                keyName="studyType"
                                                value={studyInfo.studyType}
                                            />
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="common.department" />}
                                                keyName="department"
                                                value={studyProgram}
                                            />
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="common.studyCycle" />}
                                                keyName="studyProgram"
                                                value={studyInfo.studyCycles[0].name}
                                            />
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="common.studyProgram" />}
                                                keyName="studyProgram"
                                                value={studyInfo.studyProgramBasic}
                                            />
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="professorInputGrades.currentSemester" />}
                                                keyName="currentSemester"
                                                value={currentSemester}
                                            />
                                        </Table.Body>
                                    </Table>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="sidebar.gradesOverview" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentGrades
                        studentId={this.props.location.state.sspId}
                    />
                </Tab.Pane>)
            }

        ];


        return (<div>
            <h1> <FormattedMessage id="professorInputGrades.studentInfo" /></h1>
            <Segment.Group raised >
                <Segment clearing>
                    <Header as="h3">
                        <FormattedMessage id="professorInputGrades.infoView" />
                        <Header floated="right" style={IconHeader}>
                            <Popup
                                floatd="right"
                                trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                content="Nazad"
                                hideOnScroll
                                position="top center"
                            />
                        </Header>
                    </Header>


                </Segment>
                <Segment clearing>
                    {/*{assistant ? <Grid columns={2} centered className="stackable">*/}
                    {/*    <Grid.Row >*/}
                    {/*        <Grid.Column >*/}
                    {/*            <Table celled compact>*/}
                    {/*                <Table.Header>*/}
                    {/*                    <Table.Row>*/}
                    {/*                        <Table.HeaderCell colSpan="2"><FormattedMessage id="common.image" /></Table.HeaderCell>*/}
                    {/*                    </Table.Row>*/}
                    {/*                </Table.Header>*/}
                    {/*                <Table.Body >*/}
                    {/*                    <Table.Row>*/}
                    {/*                        <Table.Cell*/}
                    {/*                            colSpan="2"*/}
                    {/*                            textAlign="center"*/}
                    {/*                            verticalAlign="middle"*/}
                    {/*                            style={{*/}
                    {/*                                height: '400px',*/}
                    {/*                                maxHeight: '500px'*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            {*/}
                    {/*                                this.state.src !== null ?*/}
                    {/*                                    <Image*/}
                    {/*                                        style={{*/}
                    {/*                                            maxWidth: '100%',*/}
                    {/*                                            maxHeight: '100%'*/}
                    {/*                                        }}*/}
                    {/*                                        src={`data:image/jpeg;base64,${this.state.src}`}*/}
                    {/*                                        centered*/}
                    {/*                                    />*/}
                    {/*                                    : <Image src="https://image.freepik.com/free-icon/user-image-with-black-background_318-34564.jpg" size="medium" centered />*/}
                    {/*                            }*/}
                    {/*                        </Table.Cell>*/}
                    {/*                    </Table.Row>*/}
                    {/*                </Table.Body>*/}
                    {/*            </Table>*/}
                    {/*        </Grid.Column>*/}
                    {/*        <Grid.Column>*/}
                    {/*            <Table celled compact>*/}

                    {/*                <Table.Header>*/}
                    {/*                    <Table.Row>*/}
                    {/*                        <Table.HeaderCell colSpan="2"><FormattedMessage id="professorInputGrades.personalInfo" /></Table.HeaderCell>*/}
                    {/*                    </Table.Row>*/}
                    {/*                </Table.Header>*/}
                    {/*                <Table.Body>*/}

                    {/*                    <SimpleTwoColumnTableRow*/}
                    {/*                        name={<FormattedMessage id="common.firstName" />}*/}
                    {/*                        keyName="firstName"*/}
                    {/*                        value={studentInfo.firstName}*/}
                    {/*                    />*/}
                    {/*                    <SimpleTwoColumnTableRow*/}
                    {/*                        name={<FormattedMessage id="common.lastName" />}*/}
                    {/*                        keyName="lastName"*/}
                    {/*                        value={studentInfo.lastName}*/}
                    {/*                    />*/}
                    {/*                    <SimpleTwoColumnTableRow*/}
                    {/*                        name={<FormattedMessage id="common.fatherName" />}*/}
                    {/*                        keyName="fatherFirstName"*/}
                    {/*                        value={studentInfo.fatherFirstName}*/}
                    {/*                    />*/}
                    {/*                    <SimpleTwoColumnTableRow*/}
                    {/*                        name={<FormattedMessage id="common.motherName" />}*/}
                    {/*                        keyName="motherFirstName"*/}
                    {/*                        value={studentInfo.motherFirstName}*/}
                    {/*                    />*/}
                    {/*                    <SimpleTwoColumnTableRow*/}
                    {/*                        name={<FormattedMessage id="common.dateOfBirth" />}*/}
                    {/*                        keyName="dateOfBirth"*/}
                    {/*                        value={moment(studentInfo.dateOfBirth).format('D. M. YYYY.')}*/}
                    {/*                    />*/}

                    {/*                </Table.Body>*/}
                    {/*            </Table>*/}
                    {/*            <Table celled compact>*/}
                    {/*                <Table.Header>*/}
                    {/*                    <Table.Row>*/}
                    {/*                        <Table.HeaderCell colSpan="2"><FormattedMessage id="professorInputGrades.contact" /></Table.HeaderCell>*/}
                    {/*                    </Table.Row>*/}
                    {/*                </Table.Header>*/}
                    {/*                <Table.Body>{contacts.map(el => (*/}
                    {/*                    <SimpleTwoColumnTableRow*/}
                    {/*                        name={el.type}*/}
                    {/*                        keyName={el.type}*/}
                    {/*                        value={el.value}*/}
                    {/*                    />*/}
                    {/*                ))}*/}

                    {/*                </Table.Body>*/}
                    {/*            </Table>*/}
                    {/*        </Grid.Column>*/}
                    {/*    </Grid.Row>*/}
                    {/*</Grid> : */}
                        <Tab
                        menu={{
                            secondary: true,
                            pointing: true,
                            color: 'blue',
                            vertical: true,
                            fluid: true,
                            attached: true,
                            tabular: true
                        }}
                        grid={{ paneWidth: 13, tabWidth: 3 }}
                        panes={panes}
                    />
                    {/*}*/}
                </Segment>
            </Segment.Group>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/StudentInfoAndGrades.js